package de.ohhhmhhh.frontend.admin.helper

fun String.validJson(): Boolean {
    return try {
        JSON.parse<dynamic>(this)
        true
    } catch (e: Throwable) {
        false
    }
}